'use strict';

export function format (number) {
    const precisionNumbers = (number + '').split('.')[1];
    let precision = precisionNumbers ? precisionNumbers.length : 0;
    return new Intl.NumberFormat([], { minimumFractionDigits: precision })
        .format(number).replace(/-/, '−');
}



// WEBPACK FOOTER //
// ./src/utils/numbers.js